// extracted by mini-css-extract-plugin
export default {"buyDongle__order2":"SmallCard_buyDongle__order2__CGqUs","buyDongle__order__text":"SmallCard_buyDongle__order__text__ztnBQ"};